module.exports = __webpack_public_path__ + "static/media/dashboard.ef93e855.svg";